import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import 'primeicons/primeicons.css';
import VueMq from 'vue-mq';

Vue.use(VueMq, {
  breakpoints: {
    mobile: 768,        // hasta 768px se considera móvil
    tablet: 1024,       // entre 769px y 1024px se considera tablet
    desktop: Infinity   // cualquier cosa por encima de 1024px es desktop
  }
});

/*import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
      id: 'G-8D7HP69ZEX',
      params: {
          send_page_view: false
      }
  }
}, router)*/

/**Google analitics */
const GA_MEASUREMENT_ID = 'G-8D7HP69ZEX'
function loadGoogleAnalytics() {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', GA_MEASUREMENT_ID)

  return gtag
}
const gtag = loadGoogleAnalytics()

router.afterEach((to) => {
  gtag('event', 'page_view', {
    page_path: to.fullPath,
    page_title: to.name,
  })
})
/**Fin Google analitics */


import 'primeicons/primeicons.css'

import * as utils from './views/utils/utilsFunctions'
Vue.prototype.$utils = utils;

import VueCookie from 'vue-cookie'

Vue.use(VueCookie)

import VModal from 'vue-js-modal'
Vue.use(VModal)

import VueNotification from "@kugatsu/vuenotification";
Vue.use(VueNotification, {dark: {background: "#117A8B", color: "#FFFFFF"}});

import 'vue-search-select/dist/VueSearchSelect.css'


/* Tabla*/
import Tabl from 'ant-design-vue/lib/table';
import Icon from 'ant-design-vue/lib/icon';
import Dropdown from 'ant-design-vue/lib/dropdown';
import Menu from 'ant-design-vue/lib/menu';
import Badge from 'ant-design-vue/lib/badge';
import DownOutlined from '@ant-design/icons-vue';

import 'ant-design-vue/dist/antd.css';

import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true,
      }
    }
  }
});

import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

const resaltar = (texto, busqueda) => {
  if (!busqueda || !texto) return texto;
  try {
    const textoLimpio = texto.replace(/[.-]/g, '');
    const posiciones = [];
    
    const regex = new RegExp(busqueda, 'gi');
    let match;
    while ((match = regex.exec(textoLimpio)) !== null) {
      // Extender la longitud de la coincidencia para incluir los caracteres especiales
      let inicio = match.index;
      let fin = match.index + busqueda.length;
      let caracteresEspecialesEnCoincidencia = texto
        .slice(inicio, fin + 1)
        .replace(/[^.-]/g, '').length;
      
      posiciones.push({
        inicio: match.index,
        fin: match.index + busqueda.length + caracteresEspecialesEnCoincidencia
      });
    }

    let resultado = texto;
    let offset = 0;
    posiciones.forEach(pos => {
      let caracteresEspeciales = texto
        .slice(0, pos.inicio)
        .replace(/[^.-]/g, '').length;
      
      const inicioReal = pos.inicio + caracteresEspeciales + offset;
      const finReal = pos.fin + caracteresEspeciales + offset;
      
      resultado = 
        resultado.slice(0, inicioReal) + 
        '<mark>' + 
        resultado.slice(inicioReal, finReal) + 
        '</mark>' + 
        resultado.slice(finReal);
      
      offset += '<mark></mark>'.length;
    });
    
    return resultado;
  } catch (e) {
    return texto;
  }
};

Vue.directive('resaltarTexto', {
  bind(el, binding) {
    const actualizar = () => {
      const textoOriginal = el.textContent || '';
      if (binding.value) {
        el.innerHTML = resaltar(textoOriginal, binding.value);
      } else {
        el.textContent = textoOriginal;
      }
    };
    actualizar();
  },

  componentUpdated(el, binding) {
    if (binding.value !== binding.oldValue) {
      const textoOriginal = el.textContent || '';
      if (binding.value) {
        el.innerHTML = resaltar(textoOriginal, binding.value);
      } else {
        el.textContent = textoOriginal;
      }
    }
  }
});

/* Funciona a medias
Vue.directive('resaltarTexto', {
    bind(el, binding) {
      el.originalText = el.textContent;
    },
    update(el, binding) {
      const filtro = binding.value;
      const texto = el.originalText;
  
      if (!filtro) {
        el.textContent = texto;
        return;
      }
  
      const regex = new RegExp(`(${filtro})`, 'gi');
      const highlighted = texto.replace(regex, match => `<mark>${match}</mark>`);
      
      el.innerHTML = highlighted;
    }
  });
  */

/*
<span class="font-weight-bold" style="font-size: 0.8rem;">(<span v-resaltarTexto="filtroTexto">{{ empresa.codEmpresa }}</span>) 
                                    <span v-resaltarTexto="filtroTexto">{{ empresa.nombreEmpresa }}</span>
                                    - <span v-resaltarTexto="filtroTexto">{{ $utils.formatearRut(empresa.rutEmpresa) }}</span>
                                
                                
                                </span>
Vue.directive('resaltarTexto', {
    bind(el, binding) {
      const resaltar = (texto, termino) => {
        if (!termino) return texto; // Si no hay término de búsqueda, no hacer nada.
  
        // Limpiar el texto para la búsqueda (eliminar puntos y guion)
        const textoLimpio = texto.replace(/[.-]/g, '');
        const terminoLimpio = termino.replace(/[.-]/g, ''); // Limpiar el término también
  
        // Crear una expresión regular para buscar el término limpio (sin puntos ni guion)
        const regex = new RegExp(`(${terminoLimpio})`, 'gi');
  
        // Reemplazar las coincidencias en el texto original (con puntos y guion) con el resaltado
        return texto.replace(regex, (match) => {
          // Aquí reemplazamos el término encontrado con un fondo amarillo
          return `<span style="background-color: yellow;">${match}</span>`;
        });
      };
  
      // Aplicar el resaltado al contenido del elemento
      el.innerHTML = resaltar(el.innerText, binding.value);
    },
    update(el, binding) {
      // Reaplicar el resaltado si el término de búsqueda cambia
      const resaltar = (texto, termino) => {
        if (!termino) return texto;
  
        // Limpiar el texto para la búsqueda (eliminar puntos y guion)
        const textoLimpio = texto.replace(/[.-]/g, '');
        const terminoLimpio = termino.replace(/[.-]/g, ''); // Limpiar el término también
  
        // Crear una expresión regular para buscar el término limpio (sin puntos ni guion)
        const regex = new RegExp(`(${terminoLimpio})`, 'gi');
  
        // Reemplazar las coincidencias en el texto original (con puntos y guion) con el resaltado
        return texto.replace(regex, (match) => {
          // Aquí reemplazamos el término encontrado con un fondo amarillo
          return `<span style="background-color: yellow;">${match}</span>`;
        });
      };
  
      // Aplicar el resaltado al nuevo texto
      el.innerHTML = resaltar(el.innerText, binding.value);
    }
  });*/

/*Vue.directive('resaltar-texto', {
    bind(el, binding) {
      // Aplica el resaltado la primera vez
      actualizarTexto(el, binding.value.texto, binding.value.filtro);
    },
    update(el, binding) {
      // Vuelve a aplicar el resaltado cuando cambie el valor
      actualizarTexto(el, binding.value.texto, binding.value.filtro);
    }
  });
  
  function actualizarTexto(el, texto, filtro) {
    if (!filtro) {
      el.innerHTML = texto; // Si no hay filtro, muestra el texto original
      return;
    }
  
    // Normaliza filtro eliminando puntos y guiones
    const filtroNormalizado = filtro.replace(/[.\-]/g, '').toLowerCase();
  
    if (!filtroNormalizado) {
      el.innerHTML = texto; // Si el filtro está vacío después de normalizar, no hace nada
      return;
    }
  
    // Normaliza texto eliminando puntos y guiones para búsqueda
    const textoNormalizado = texto.replace(/[.\-]/g, '').toLowerCase();
  
    // Inicializamos variables para construir el texto resaltado
    let textoResaltado = '';
    let inicio = 0;
  
    while (inicio < texto.length) {
      // Encuentra el índice de la siguiente coincidencia en el texto normalizado
      const indiceNormalizado = textoNormalizado.indexOf(filtroNormalizado, inicio);
  
      if (indiceNormalizado === -1) {
        // No se encuentran más coincidencias, agrega el resto del texto
        textoResaltado += texto.slice(inicio);
        break;
      }
  
      // Encuentra los índices reales en el texto original
      const inicioOriginal = buscarIndiceOriginal(texto, textoNormalizado, inicio, indiceNormalizado);
      const finOriginal = buscarIndiceOriginal(texto, textoNormalizado, inicio, indiceNormalizado + filtroNormalizado.length);
  
      // Agrega el texto previo a la coincidencia
      textoResaltado += texto.slice(inicio, inicioOriginal);
  
      // Resalta la coincidencia
      textoResaltado += `<span style="background-color: yellow; font-weight: bold;">${texto.slice(inicioOriginal, finOriginal)}</span>`;
  
      // Avanza el índice al final de la coincidencia resaltada
      inicio = finOriginal;
    }
  
    el.innerHTML = textoResaltado; // Aplica el texto resaltado al elemento
  }
  
  // Función para mapear índices del texto normalizado al texto original
  function buscarIndiceOriginal(texto, textoNormalizado, inicioOriginal, indiceNormalizado) {
    let indiceReal = inicioOriginal;
    let contadorNormalizado = 0;
  
    while (indiceReal < texto.length && contadorNormalizado < indiceNormalizado) {
      if (/[a-zA-Z0-9]/.test(texto[indiceReal])) {
        contadorNormalizado++;
      }
      indiceReal++;
    }
  
    return indiceReal;
  }*/
  
  
  
  

/*import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'

Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#fff',
  background: '#000',
  borderRadius: 12,
  fontWeight: 400,
})*/

//import { tippy } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

//import { DocumentEditorPlugin, DocumentEditorContainerPlugin } from '@syncfusion/ej2-vue-documenteditor';

//Vue.use(DocumentEditorPlugin);
//Vue.use(DocumentEditorContainerPlugin);

import VueCurrencyFilter from 'vue-currency-filter'


import VueTailwind from 'vue-tailwind'
import {TDropdown,} from 'vue-tailwind/dist/components'

const settings = {
  't-dropdown': {
    component: TDropdown,
    props: {
      fixedClasses: {
        button: 'flex items-center text-white block px-4 py-2 transition duration-100 ease-in-out border border-transparent rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
        wrapper: 'inline-flex flex-col',
        dropdownWrapper: 'relative z-10',
        dropdown: 'origin-top-left absolute left-0 w-56 rounded shadow mt-1',
        enterClass: 'opacity-0 scale-95',
        enterActiveClass: 'transition transform ease-out duration-100',
        enterToClass: 'opacity-100 scale-100',
        leaveClass: 'opacity-100 scale-100',
        leaveActiveClass: 'transition transform ease-in duration-75',
        leaveToClass: 'opacity-0 scale-95'
      },
      classes: {
        button: 'bg-blue-500 hover:bg-blue-600',
        dropdown: 'bg-white'
      },
      variants: {
        danger: {
          button: 'bg-red-500 hover:bg-red-600',
          dropdown: 'bg-red-50'
        }
      }
    }
  }
}

Vue.use(VueTailwind, settings)

Vue.use(VueCurrencyFilter, [
    {
    symbol : '$',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: ''
    },
    {
    name: 'soloNumeros',
    symbol: '',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'back',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
    },
    {
    name: 'dosDecimales',
    symbol: '$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
    },
    {
    name: 'currency1',
    symbol: '%',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'back',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
    },
    {
    name: 'currency2',
    symbol: '%',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'back',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
    },
    {
    name: 'currency3',
    symbol: '%',
    thousandsSeparator: '.',
    fractionCount: 1,
    fractionSeparator: ',',
    symbolPosition: 'back',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
    }]
)

Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
});

Vue.component(Tabl.name, Tabl);
Vue.component(Icon.name, Icon);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DownOutlined.name, DownOutlined);
Vue.component(Menu.name, Menu);
Vue.component(Badge.name, Badge);

/* fin tabla*/

import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax,  {
    colors: {
      primary:'#5b3cc4',
      success:'rgb(23, 201, 100)',
      danger:'rgb(242, 19, 93)',
      warning:'rgb(255, 130, 0)',
      dark:'rgb(36, 33, 69)'
    }
  })


/*
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css';

Vue.component('Datepicker', VueDatepickerUi)

import 'v2-datepicker/lib/index.css';   // v2 need to improt css
import V2Datepicker from 'v2-datepicker';

Vue.use(V2Datepicker)


import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

import DatetimePicker from 'vuetify-datetime-picker'
 
Vue.use(DatetimePicker)*/


/*import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

Vue.use(AirbnbStyleDatepicker, {
  sundayFirst: false,
  texts: {
    apply: 'Aplicar',
    cancel: 'Cancelar',
    keyboardShortcuts: 'Keyboard Shortcuts',
  },
  days: ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'],
  daysShort: ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab','Dom'],
  monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio','Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  keyboardShortcuts: [
    {symbol: '↵', label: 'Seleccionar fecha', symbolDescription: 'Enter key'},
    {symbol: '←/→', label: 'Mueve un día hacia atrás (izquierda) y adelante (derecha).', symbolDescription: 'Left or right arrow keys'},
    {symbol: '↑/↓', label: 'Mover una semana hacia atrás (arriba) y hacia adelante (abajo).', symbolDescription: 'Up or down arrow keys'},
    {symbol: 'PgUp/PgDn', label: 'Cambiar mes.', symbolDescription: 'PageUp and PageDown keys'},
    {symbol: 'Home/End', label: 'Desplazer al primer/último día de la semana.', symbolDescription: 'Home or End keys'},
    {symbol: 'Esc', label: 'Cerrar ayuda', symbolDescription: 'Escape key'},
    {symbol: '?', label: 'Abrir ayuda', symbolDescription: 'Question mark'}
  ]
})*/

/**
 * 
 * @param {int} tipo "1-success, 2-warning, 3-error, (Cualquier Otro)-info" 
 * @param {string} mensaje "Mensaje de la notificacion"
 */
Vue.prototype.mostrarNotificaciones = function (tipo, mensaje, tiempo=10) {
  var propiedadesNotificaciones = {timer: tiempo, position:"bottomRight"}
  if(tipo == 1){
    this.$notification.success(mensaje, propiedadesNotificaciones);
  }
  else if(tipo == 3){
    this.$notification.error(mensaje, propiedadesNotificaciones);
  }
  else if(tipo == 2){
    this.$notification.warning(mensaje, propiedadesNotificaciones);
  }
  else{
    this.$notification.dark(mensaje, propiedadesNotificaciones);
  }             
}

Vue.prototype.getBaseTippy = function(mensaje) {
  return { placement: 'top',arrow: true, animation:'perspective', theme: 'google', followCursor : true, content: mensaje}
}

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
